import { createContext, useContext } from "react";
import { LangDto } from "@client/common";

interface LangContextProps {
  lang: LangDto;
  setLang: (lang: LangDto) => void;
}

export const LangContext = createContext<LangContextProps>({
  lang: LangDto.PL,
  setLang: () => null,
});
export const useLangContext = () => useContext(LangContext);
